exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".search-found[data-oc-tree-search-plugin-css]{\n    color: #DC354B\n}", ""]);

